export enum PermissionCategories {
  Audits = 'audits',
  Contracts = 'contracts',
  Financials = 'financials',
  Schedule = 'schedule',
  Findings = 'findings',
  Certificates = 'certificates',
}

export enum PermissionsList {
  NoAccess = 'noAccess',
  View = 'view',
  Edit = 'edit',
  Submit = 'submit',
}
